import { ActionsCreator } from '@/store/utils';

export default ActionsCreator([
  {
    name: 'getNews',
    mutation: 'GET_NEWS'
  }
]);
